import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { catchError, map, Observable, of } from 'rxjs';
import { LoginService } from './pages/login/login.service';
import { setLoggedInUser } from './Store/request.actions';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(private router: Router, private loginService : LoginService, private store : Store) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    return this.loginService.checkLogin().pipe(
      map((response: any) => {
        if (response.status === 'authenticated') {
          return true;
        } else {
          this.store.dispatch(setLoggedInUser({request : null}));
          this.router.navigate(['/login']);
          return false;
        }
      }),
      catchError(() => {
        this.store.dispatch(setLoggedInUser({request : null}));
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
